













































































































import { Component, Vue, Inject } from 'vue-property-decorator'
import TenantSwitch from '../components/tenant-switch.vue'
import LanguageSwitch from '../components/language-switch.vue'
import ViewUI from 'view-design'
import AbpBase from '../lib/abpbase'

@Component({
  components: { TenantSwitch, LanguageSwitch },
})
export default class Login extends AbpBase {
  loginModel = {
    userNameOrEmailAddress: '',
    password: '',
    verifyCode: '',
    guid: '',
    rememberMe: false,
  }
  showChangeTenant: boolean = false
  switchPassDisFlag: boolean = true

  async getCode() {
    await this.$store.dispatch({
      type: 'app/getVerifyCode',
    })
  }

  get verifyImg() {
    return this.$store.state.app.verifyCode
  }

  async login() {
    ;(this.$refs.loginform as any).validate(async (valid: boolean) => {
      if (valid) {
        this.$Message.loading({
          content: '登录中',
          duration: 0,
        })
        let _this = this
        _this.loginModel.guid = _this.$store.state.app.guid
        setTimeout(function () {
          _this.getCode()
        }, 500)
        await this.$store.dispatch({
          type: 'app/login',
          data: this.loginModel,
        })
        sessionStorage.setItem('rememberMe', this.loginModel.rememberMe ? '1' : '0')
        location.reload()
      }
    })
  }

  SwitchPassDis() {
    this.switchPassDisFlag = !this.switchPassDisFlag
  }

  get tenant() {
    return this.$store.state.session.tenant
  }

  validatePassCheck = (rule: any, value: any, callback: any) => {
    if (!value) {
      callback(new Error('验证码不能为空'))
    } else if (!(value.length == 4)) {
      callback(new Error('只能输入4位数'))
    } else {
      callback()
    }
  }

  rules = {
    userNameOrEmailAddress: [{ required: true, message: this.L('必填信息'), trigger: 'blur' }],
    password: [{ required: true, message: this.L('必填信息'), trigger: 'blur' }],
    verifyCode: [
      { required: true, message: '验证码不能为空', trigger: 'blur' },
      { validator: this.validatePassCheck, message: '只能输入4位数', trigger: 'blur' },
    ],
  }

  register() {
    this.$router.push('/register')
  }

  forgetPassword() {
    this.$Modal.info({
      title: '提示',
      content: '请联系管理员重置密码',
    })
  }

  mounted() {
    this.getCode()
  }

  created() {
    let _this = this
    document.onkeydown = function (e) {
      if (e.keyCode) {
        if (e.keyCode == 13) {
          _this.login()
        }
      }
    }
  }
}
